import { render } from "./Wheel12.vue?vue&type=template&id=257567c9"
const script = {}
script.render = render

export default script